import { Roles } from './types';

export const AUTHORIZED_ROLES = [
  Roles.Spv,
  Roles.Bm,
  Roles.Abpm,
  Roles.Am,
  Roles.HoViewer,
  Roles.HoEditor,
  Roles.HoApprover,
];
